module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon6.913a6a6c.svg";